<template>
  <div class="container px-0">
    <!-- <div class="row mb-3">
      <div class="col-8">
        <h2 class="typo-h5 ">New Video</h2>
      </div>
      <div class="col-4">
        <h2 class="typo-h5 ">Recommended</h2>
      </div>
    </div>-->
    <Portal to="headerActions" v-if="inRoute">
      <div class="col-12 col-mlg-7 ml-auto mt-1 mt-sm-0">
        <div class="row justify-content-center justify-content-sm-end">
          <a href="https://www.youtube.com/channel/UCRUP8zvEDtEJrRtqCjbLJ0w" target="_blank" class="btn btn-lg btn-primary typo-button14 typo-medium btn-default">
            <span class="mr-1">
              <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="open-external">
                <path fill="currentColor" d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM474.67,0H316a28,28,0,0,0-28,28V46.71A28,28,0,0,0,316.79,73.9L384,72,135.06,319.09l-.06.06a24,24,0,0,0,0,33.94l23.94,23.85.06.06a24,24,0,0,0,33.91-.09L440,128l-1.88,67.22V196a28,28,0,0,0,28,28H484a28,28,0,0,0,28-28V37.33h0A37.33,37.33,0,0,0,474.67,0Z"/>
              </svg>
            </span>
            <span>{{ $t("academy.youtube") }}</span>
          </a>
        </div>
      </div>
    </Portal>
    <div class="bb1sg"></div>
    <div class="row mt-3">
      <div class="col-9">
        <h2 class="typo-h5">{{$t("generals.topics")}}</h2>
      </div>
      <div class="col-3">
        <!-- <router-link
          :to="{ name: 'Topics' }"
          class="typo-body3 text-secondary3 d-flex justify-content-end"
        >View All</router-link>-->
      </div>
    </div>
    <div class="row relative">
      <!-- <div class="mt-2 col-12" v-if="topic.loading">
      </div> -->
      <!-- <GLoading class="mx-2" v-if="topic.loading"/> -->
      <template v-if="topic.fetched">
        <template v-if="topic.list.length">
          <TopicItem :item="topic" v-for="(topic, ind) in sortedTopic" :key="ind" />
        </template>
        <template v-else>
          <GpEmptyPage page="videoTutorial" />
        </template>
      </template>
      <template v-else>
        <TopicItem v-for="ind in 6" :key="ind" />
      </template>
    </div>
  </div>
</template>

<script>
import { TopicItem } from "../components";
import { mapState } from "vuex";
import GpEmptyPage from "@/core/shared/GpEmptyPage";
export default {
  name: "TutorialDefault",
  components: {
    TopicItem,
    GpEmptyPage
  },
  data() {
    return {
      inRoute: false,
    };
  },
  computed: {
    ...mapState({
      allTopics: state => state.tutorial.topics,
      topic: state => state.tutorial.topic
    }),
    topics() {
      if (!this.allTopics) return [];
      return this.allTopics.map(item => {
        item.title = this.$t(item.title);
        item.describes = this.$t(item.describes);
        return item;
      });
    },
    sortedTopic() {
      let list = [...(this.topic.list || [])];
      list.sort((a, b) => {
        if (a.id == "PLoyQ7pcHx_pRj6sMwBdLihO8SvBjZaJpn") return -1;
        if (b.id == "PLoyQ7pcHx_pRj6sMwBdLihO8SvBjZaJpn") return 1;
        if (a.id == "PLoyQ7pcHx_pQzkZrAIQQGTVz7jWypOesk") return -1;
        if (b.id == "PLoyQ7pcHx_pQzkZrAIQQGTVz7jWypOesk") return 1;
        if (a.id == "PLoyQ7pcHx_pQrXJYRkM9Q75DqiXHp90SJ") return -1;
        if (b.id == "PLoyQ7pcHx_pQrXJYRkM9Q75DqiXHp90SJ") return 1;
        return (b.contentDetails.itemCount - a.contentDetails.itemCount);
      });
      return list;
    }
  },
  mounted() {
    this.inRoute = true;
  },
  beforeDestroy() {
    this.inRoute = false;
  },
  methods: {
    onTabChangeHandler() {}
  }
};
</script>

<style lang="scss" scoped>

.bb1sg {
  border-bottom: 1px solid $grey3;
}
.relative {
  min-height: 400px;
}
.open-external {
  $size: 12px;
  width: $size;
  height: $size;
}
</style>
